import React from 'react';
import InOutInventoryMaterials from 'components/app/erp/InOutInventoryMaterials';

// Route-level page entry for ERP In-Out Materials.
const InOutInventoryMaterialPage = () => <InOutInventoryMaterials />;

export default InOutInventoryMaterialPage;
